import React, { useState, useRef } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import HubspotForm from 'react-hubspot-form';

import Modal from 'react-scale/components/tailwind/Modal';
import Spinner from 'react-scale/components/ui/spinner';
import Button from 'react-scale/components/ui/button';

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};

const ModalForm = ({
  campaign,
  label,
  title,
  formContainerCN,
  formId,
  sfdcCampaignId,
  theme,
  themeColors,
  size
}) => {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const formWrapperRef = useRef();

  const toggleModal = () => {
    setShowModal(!showModal);
    if (campaign) {
      router.replace(`${router.pathname}?utm_campaign=${campaign}`);
    }
  };

  return (
    <div>
      <Button
        text={label}
        theme={theme}
        size={size}
        themeColors={themeColors}
        onClick={toggleModal}
        fullWidth
      />
      <Modal
        title={title ?? label}
        isShowing={showModal}
        hide={() => setShowModal(false)}
        contentClassName="max-w-lg"
      >
        <div className={formContainerCN} ref={formWrapperRef}>
          <HubspotForm
            portalId="4823527"
            formId={formId}
            sfdcCampaignId={sfdcCampaignId}
            target={`.${formContainerCN}`}
            submitButtonClass={cn(
              'hs-button',
              'bg-black text-white font-medium text-base px-6 py-3 leading-relaxed inline-block rounded-full whitespace-nowrap cursor-pointer'
            )}
            onReady={() => setHiddenUTMFields()}
            loading={<Spinner size="lg" />}
          />
        </div>
      </Modal>
    </div>
  );
};

ModalForm.defaultProps = {
  theme: 'dark',
  label: 'Get Early Access',
  formId: 'cd4ebc8d-46b4-4068-9ffe-a308d84d10ae',
  sfdcCampaignId: '701f40000019yL2AAI',
  formContainerCN: 'hubspot-subscribe', // custom className for when there are multiple modals in the same page
  campaign: null
};

export default ModalForm;
